import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import { noop } from 'lodash-es';
import Button from 'sushiweb/Button/Button';
import ChevronDown from 'sushiweb/Icons/all/ChevronDown';
import Download from 'sushiweb/Icons/all/Download';
import Upload from 'sushiweb/Icons/all/Upload';
import OnClickOutside from 'sushiweb/HOC/OnClickOutside';
import grey from 'sushiweb/tokens/color/grey';
import { openErrorToast, openSuccessToast } from '../../../reducers/uiLogic';
import { getAllQuestionsInitiate } from '../../../actions/questions';
import { questionTypeEnum, optionDataTypeEnum } from '../../common/components/constants';
import UploadOptionsModal from './UploadOptionsModal';
import {
  ManageOptionsWrapper,
  ManageOptionsButton,
  DropdownMenu,
  DropdownItem,
} from './styles';

const downloadFromUrl = (url, filename) => {
  const link = document.createElement('a');
  link.href = url;
  link.download = filename || 'options.csv';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const UploadOptionsAction = ({ data, companyId, showErrorToast, showSuccessToast, getAllQuestions }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // works only for single and multiple select question with option data type as custom csv
  const isSingleOrMultiSelect =
    data?.question_type === questionTypeEnum.SINGLE_OPTION ||
    data?.question_type === questionTypeEnum.MULTIPLE_OPTIONS;
  const isCustomCsv = data?.option_data_type === optionDataTypeEnum.CUSTOM_CSV;

  if (!(isSingleOrMultiSelect && isCustomCsv)) {
    return '—';
  }

  const hasExistingOptions = !!data?.options_csv_url;

  const handleDownload = () => {
    if (!data?.options_csv_url) {
      showErrorToast('No options file available to download.');
      return;
    }
    downloadFromUrl(data.options_csv_url, `options_${data?.question_id || 'file'}.csv`);
    setIsDropdownOpen(false);
  };

  const handleOverwrite = () => {
    setIsDropdownOpen(false);
    setIsOpen(true);
  };

  if (hasExistingOptions) {
    return (
      <>
        <OnClickOutside
          handleClickOutside={() => setIsDropdownOpen(false)}
          removeHandler={!isDropdownOpen}
        >
          <ManageOptionsWrapper>
            <ManageOptionsButton
              appearance='primary'
              size='small'
              icon={<ChevronDown size={14} />}
              iconAlign='right'
              onClick={() => setIsDropdownOpen(prev => !prev)}
            >
              Manage Options
            </ManageOptionsButton>
            {isDropdownOpen && (
              <DropdownMenu>
                <DropdownItem onClick={handleDownload}>
                  <Download size={16} color={grey.z800} />
                  Download current Options (CSV)
                </DropdownItem>
                <DropdownItem onClick={handleOverwrite}>
                  <Upload size={16} color={grey.z800} />
                  Overwrite Options
                </DropdownItem>
              </DropdownMenu>
            )}
          </ManageOptionsWrapper>
        </OnClickOutside>
        <UploadOptionsModal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          data={data}
          companyId={companyId}
          showErrorToast={showErrorToast}
          showSuccessToast={showSuccessToast}
          onUploadSuccess={getAllQuestions}
        />
      </>
    );
  }

  return (
    <>
      <Button appearance='outline' size='small' onClick={() => setIsOpen(true)}>
        Upload Options
      </Button>
      <UploadOptionsModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        data={data}
        companyId={companyId}
        showErrorToast={showErrorToast}
        onUploadSuccess={getAllQuestions}
      />
    </>
  );
};

UploadOptionsAction.propTypes = {
  data: PropTypes.objectOf(PropTypes.any),
  companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showErrorToast: PropTypes.func,
  showSuccessToast: PropTypes.func,
  getAllQuestions: PropTypes.func,
};

UploadOptionsAction.defaultProps = {
  data: {},
  companyId: '',
  showErrorToast: noop,
  showSuccessToast: noop,
  getAllQuestions: noop,
};

const mapStateToProps = state => ({
  companyId: _get(state, 'user.selectedWorkspace.company_id', ''),
});

const mapDispatchToProps = dispatch => ({
  showErrorToast: message => dispatch(openErrorToast(message)),
  showSuccessToast: message => dispatch(openSuccessToast(message)),
  getAllQuestions: payload => dispatch(getAllQuestionsInitiate(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UploadOptionsAction);
